import React from "react";
import TopoTexture from "@/components/TopoTexture";
import QuoteForm from "@/components/QuoteForm";
import { Phone, Mail, MapPin, Clock, Facebook } from "lucide-react";
import { COMPANY } from "@/data/site";

const QuoteSection = () => {
  return (
    <section id="quote" data-testid="quote-section" className="relative py-20 md:py-32 bg-[var(--ct-bg)] overflow-hidden">
      <TopoTexture variant="light" opacity={0.03} />
      <div className="section-container relative">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="label-xs text-[var(--ct-primary)] mb-3">Free Moving Quote</div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-[var(--ct-primary)] tracking-tight" style={{ fontFamily: "Outfit" }}>
              Get your free Casper moving quote in minutes.
            </h2>
            <p className="mt-5 text-[var(--ct-text-muted)] leading-relaxed">
              Tell us about your move in Casper, Mills, or surrounding Wyoming areas. We'll follow up quickly
              with a transparent, no-obligation estimate.
            </p>

            <div className="mt-10 space-y-5">
              <ContactRow icon={<Phone />} label="Call Anytime">
                <a href={`tel:${COMPANY.phoneTel}`} className="font-semibold text-[var(--ct-primary)] hover:text-[var(--ct-secondary)]">
                  {COMPANY.phone}
                </a>
              </ContactRow>
              <ContactRow icon={<Mail />} label="Email">
                <a href={`mailto:${COMPANY.email}`} className="font-medium">{COMPANY.email}</a>
              </ContactRow>
              <ContactRow icon={<MapPin />} label="Headquarters">
                {COMPANY.address}
              </ContactRow>
              <ContactRow icon={<Clock />} label="Hours">
                {COMPANY.hours}
              </ContactRow>
              <ContactRow icon={<Facebook />} label="Facebook">
                <a
                  href={COMPANY.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Follow Crosstown Movers on Facebook"
                  data-testid="contact-facebook"
                  className="inline-block py-2 font-medium hover:text-[var(--ct-primary)] rounded focus-visible:outline-2 focus-visible:outline-[var(--ct-primary)]"
                >
                  Follow us on Facebook
                </a>
              </ContactRow>
              <ContactRow icon={<MapPin />} label="Google">
                <a
                  href={COMPANY.googleMaps}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Find Crosstown Movers on Google Maps"
                  data-testid="contact-google"
                  className="inline-block py-2 font-medium hover:text-[var(--ct-primary)] rounded focus-visible:outline-2 focus-visible:outline-[var(--ct-primary)]"
                >
                  Find us on Google
                </a>
              </ContactRow>
            </div>
          </div>

          <div className="lg:col-span-7">
            <QuoteForm />
          </div>
        </div>
      </div>
    </section>
  );
};

const ContactRow = ({ icon, label, children }) => (
  <div className="flex items-start gap-4">
    <div className="w-11 h-11 rounded-xl bg-white border border-[var(--ct-border)] flex items-center justify-center text-[var(--ct-primary)]">
      {React.cloneElement(icon, { className: "w-5 h-5" })}
    </div>
    <div>
      <div className="text-xs font-bold uppercase tracking-[0.2em] text-[var(--ct-text-muted)]">{label}</div>
      <div className="mt-1 text-[var(--ct-text)]">{children}</div>
    </div>
  </div>
);

export default QuoteSection;
